import { RichMediaValue } from '@/interface/media';

import { IAudioContent } from './imMessage';

export interface IBot {
  id: string;
  relatedId: string;
  name: string;
  bgImage: RichMediaValue;
  foreImage: RichMediaValue;
  intro: string;
  closeUp: string;
  avatar: RichMediaValue;
  chatBackground: RichMediaValue;
  phases: string;
  ttsEnabled: boolean;
}

export enum ReplaceType {
  REPLACE_TYPE_UNKNOWN = 0,
  REPLACE_TYPE_Q_REV_A_FOR = 1,  // 对Q进行new->old的词条替换；对A进行old->nes的词条替换
  REPLACE_TYPE_A_FOR = 2,     // 对A进行old->nes的词条替换
}

export interface IReplaceMsgTextInfo {
  old: string;
  new: string
  type: ReplaceType
}

export enum ScheduleType {
  SCHEDULE_TYPE_UNKNOWN = 0,
  SCHEDULE_TYPE_ONCE,
  SCHEDULE_TYPE_DAILY
}

export interface ITimeType {
  date?: string;
  moment: string;
}

export interface ISchedule {
  scheduleType: ScheduleType;
  startTime: ITimeType;
  endTime: ITimeType;
  fixedReplies: string[]
}

export interface IStory {
  id: string;
  name: string;
  image: RichMediaValue;
  subtitle: string;
  intro: string;
  background: string;
  backgroundUrl: RichMediaValue;
  startButton: RichMediaValue;
  bgm: IAudioContent;
  createdBy: string | null;
  playerInfo: { name: string; avatar: RichMediaValue };
  bots: IBot[];
  scenes: IScene[];
}

export interface IScene {
  id: string;
  name: string;
  image: RichMediaValue;
  background: string | null;
  foregroundImage: RichMediaValue;
  bgm: IAudioContent;
  events: string | null;
  countDown: number;
  finalScene: boolean;
  bots: IBot[];
}

export interface ISpace {
  id: string;
  name: string;
  bannerUrl: RichMediaValue;
  coverUrl: RichMediaValue;
  intro: string;
  stories: IStory[];
}

export enum MissionStatusType {
  MISSIONSTATUSTYPE_DEFAULT = 0,
  MISSIONSTATUSTYPE_GOING,
  MISSIONSTATUSTYPE_SUCCESS,
  MISSIONSTATUSTYPE_FAILURE,
}

export interface ISceneMission {
  sceneId: string;
  sceneName: string;
  condition: string;
  completedMissions: string[];
  missions: IMission[];
  nextSceneId: string;
  missionStatus: MissionStatusType;
}

export interface IMission {
  id: string;
  name: string;
  desc: string;
  image: RichMediaValue;
  isNecessary: boolean;
  clue: string;
}
